/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ls from "local-storage";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { db, storage } from "../../Firebase/firebase.js";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);
const tablestyle = {
  backgroundColor: "#171942",
  color: "white",
};

export default function Chances() {
  let history = useHistory();
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));
  const [rows, setRow] = React.useState([]);
  const [product_type, setType] = React.useState("Door");

  React.useEffect(() => {
    getChances();
  }, []);

  const handleTypeChange = (event) => {
    setType(event.target.value);
    let newArray = [];
    db.collection("category")
      .doc(event.target.value)
      .collection("tickets")
      // .where("uid", "==", ls.get("currentcustomerUid"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  const getChances = () => {
    let newArray = [];
    db.collection("category")
      .doc(product_type)
      .collection("tickets")
      // .where("uid", "==", ls.get("currentcustomerUid"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  const classes = useStyles();
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "500px" : "50px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: 262 }}
            >
              
              <InputLabel id="type_label">Category</InputLabel>
              <Select
                labelId="type_id"
                id="product_type"
                value={product_type}
                onChange={handleTypeChange}
                label="Category"
                defaultValue={product_type}
              >
                <MenuItem value={"Door"}>Door</MenuItem>
                <MenuItem value={"Medium"}>Medium</MenuItem>
                <MenuItem value={"Large"}>Large</MenuItem>
              </Select>
            </FormControl>
          </div>
        </GridItem>
        {/* <GridItem xs={8} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "00px" : "5px" }}>
          <TextField
              placeholder="Search by Name"
              variant="outlined"
              //inputRef={searchref}
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment>
              //       <IconButton onClick={searchFisherman}>
              //         {searchflag ? <SearchIcon /> : <ClearIcon />}
              //       </IconButton>
              //     </InputAdornment>
              //   ),
              // }}
            />
            </div>
          </GridItem> */}
      </GridContainer>
      <br></br>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflow: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tablestyle}>Registration ID</TableCell>
                  <TableCell style={tablestyle} align="left">
                    Name
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Category
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Chances
                  </TableCell>
                  {product_type==="Large"?
                  <TableCell style={tablestyle} align="left">
                    Action
                  </TableCell>
                  : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.docId}>
                    <TableCell component="th" scope="row">
                      {row.registerationId}
                    </TableCell>

                    <TableCell align="left">{row.registerationName}</TableCell>
                    <TableCell align="left">{product_type}</TableCell>
                    <TableCell align="left">{row.ticket_count}</TableCell>
                    {product_type==="Large"?
                    <TableCell align="left">
                      {/* <div>
                        <Button
                          style={{
                            textTransform: "none",
                            backgroundColor: "#171942",
                            color: "white",
                          }}
                          variant="contained"
                          color="default"
                          className={classes.button}
                          startIcon={<AddCircleIcon />}
                        >
                          Edit Chances
                        </Button>
                      </div> */}
                    </TableCell>
                    :null}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
    </>
  );
}
